import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./styled/modal.scss";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../address";
export const ModalSuspend = ({ action = false }) => {
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("global");

  // تابع کمکی برای به‌روزرسانی وضعیت open
  const updateOpenState = () => {
    setOpen(/true/.test(action));

    const x = document.getElementById("demo");
  };

  useEffect(() => {
    updateOpenState(); // فراخوانی تابع کمکی
  }, [action]); // اضافه کردن action به آرایه وابستگی‌ها
  return (
    <>
      <Modal
        width={"28rem"}
        onClick={() => true}
        centered
        ok
        // open={open}
        footer={[
          <div className="holder-footer">
            <Button
              danger
              className="btn-normal btn-aptel"
              onClick={() => {
                setOpen((prev) => !prev);
              }}
            >
              {t("suspend.buttonText")}
            </Button>
          </div>,
        ]}
      >
        <div className="holder-show-locker-account">
          <div className="holder-icon">
            <div className="show-icon">
              <i className="icon-lock-normal"></i>
            </div>
          </div>
          <div className="holder-title">
            <h3>{t("suspend.title")}</h3>
          </div>
          <div className="holder-body">
            <p dangerouslySetInnerHTML={{ __html: t("suspend.description") }} />
          </div>
        </div>
      </Modal>
    </>
  );
};

export const ModalSuccess = ({ action = false }) => {
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("global");
  const nav = useNavigate();

  useEffect(() => {
    if (action) {
      setOpen(true);
    }
  }, [action]); // اضافه کردن action به آرایه وابستگی‌ها
  return (
    <>
      <Modal
        width={"20rem"}
        centered
        onCancel={() => {
          setOpen((prev) => !prev);
        }}
        onClick={() => true}
        open={open}
        closeIcon={false}
        maskClosable={false}
        footer={[
          <div className="holder-footer">
            <Button
              danger
              className="btn-normal btn-aptel"
              onClick={() => {
                setOpen((prev) => !prev);
                nav(_adr.Root + _adr.Home, { replace: true });
              }}
            >
              ورود به سامانه
            </Button>
          </div>,
        ]}
      >
        <div className="holder-modal-success">
          <div className="holder-icon">
            <div className="holder-show">
              <i className="icon-true"></i>
            </div>
          </div>
          <div className="holder-body">
            <h3>رمز عبور شما با موفقیت تغییر کرد</h3>
          </div>
        </div>
      </Modal>
    </>
  );
};
